import { TouchableOpacity } from 'react-native';

import { Text } from '@squire/ui';

import { pressedState } from '@/utils/a11y';

import { styles } from './styles';
import type { TipItemProps } from './types';

const TipItem = (props: TipItemProps) => {
  const {
    children,
    onPress,
    selected,
    inverted = false,
    variant = 'segmented',
    isCustomSlot = false,
    equalWidthChips = false,
    accessibilityLabel,
    accessibilityHint,
    accessibilityRole = 'button',
    testID,
    disabled,
  } = props;

  styles.useVariants({
    selected,
    disabled,
    inverted,
    variant,
    isCustomSlot,
    equalWidthChips,
  });

  return (
    <TouchableOpacity
      testID={testID}
      onPress={onPress}
      disabled={disabled}
      key={children || 'none'}
      {...pressedState(selected)}
      accessibilityHint={accessibilityHint}
      accessibilityRole={accessibilityRole}
      accessibilityLabel={accessibilityLabel}
      style={styles.tipItem}
    >
      <Text variant="m" numberOfLines={1} style={styles.tipItemText}>
        {children}
      </Text>
    </TouchableOpacity>
  );
};

TipItem.displayName = 'TipItem';
export { TipItem };
